import React, { useLayoutEffect, useState } from 'react';
import userProfile from '../../images/man.png';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginAction } from '../../redux/actions/Index';
import { User, GearSix, SignOut } from '@phosphor-icons/react';

function ProfileModal({ logoutTime }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const ProfileImage = useSelector((state) => state?.ModalReducer?.userimg);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    useLayoutEffect(() => {
    }, [ProfileImage])

    return (
        <div className="">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle className="user-img border-0 bg-transparent">
                    <img
                        className="img-fit" style={{ borderRadius: "50% " }}
                        src={ProfileImage ? ProfileImage : userProfile} alt="User_Profile"
                    />
                </DropdownToggle>
                <DropdownMenu className='mt-3 shadow-lg bg-body rounded-4 border-0 dropdowndata p-3 '>
                    <DropdownItem className='border-0 outline-none px-3 py-2 d-flex align-items-center'>

                        <Link className='text-dark text-decoration-none d-flex align-items-center gap-3  dropdown-item p-0' to='/Settings'><User size="26" /><span className="title-font-500 fs-3">Profile</span></Link>

                    </DropdownItem>
                    <DropdownItem className='border-0 outline-none  px-3 py-2 d-flex align-items-center'>
                        <Link className='text-dark text-decoration-none d-flex align-items-center gap-3  dropdown-item p-0' to='/Lot_intent'><GearSix size="25" /><span className="title-font-500 fs-3">Setting</span></Link>

                    </DropdownItem>
                    <DropdownItem className='border-0 outline-none  px-3 py-2 d-flex align-items-center'>
                        <SignOut size="30" className='text-danger' /><Link className='text-decoration-none title-font-500 fs-3 dropdown-item text-danger' to='' onClick={logoutTime} >Logout</Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    );
}


export default ProfileModal;